export default function MySQL_AVG() {
  return (
    <div>
      <h2>MySQL_AVG</h2>    </div>
  );
}